module.exports = __webpack_public_path__ + "static/media/drag_icon.0881e127.svg";